/** Shared swipe actions for legacy lists and registered React roots. */
(function() {
    'use strict';

    var ROW = '[data-swipe-row]';
    var PANEL = '[data-swipe-panel]';
    var DESKTOP = '[data-swipe-desktop]';
    var ACTION = '[data-swipe-panel] [data-swipe-action]';
    var REACT_ROW = '[data-react-swipe-row]';
    var REACT_PANEL = '[data-react-swipe-panel]';
    var REACT_ACTION = '[data-react-swipe-panel] [data-react-swipe-action]';
    var REVEAL_THRESHOLD_PX = 30;
    var HIDE_THRESHOLD_PX = 10;
    var DIRECTION_LOCK_PX = 10;
    var VERTICAL_ABORT_PX = 30;
    var DRAG_RELEASE_MS = 100;
    var RESIZE_DEBOUNCE_MS = 150;
    var registrations = [];
    var touchStartX = 0;
    var touchStartY = 0;
    var currentGesture = null;
    var actionHandledButton = null;
    var dragReleaseTimer = null;
    var resizeTimer = null;
    var listenersAttached = false;

    function isTouchDevice() {
        return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0);
    }

    function isMobileDevice() {
        if (typeof window.is_mobile_browser === 'function') return window.is_mobile_browser();
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent) ||
            /windows phone/i.test(userAgent) || /mobile/i.test(userAgent);
    }

    // Copied in app/Service/Web/Views/bookmarks/_swipe-ui-probe.twig for the server skeleton.
    function shouldUseSwipeInterface() {
        return isMobileDevice() || (isTouchDevice() && window.innerWidth < 768);
    }

    function registrationFor(element) {
        for (var index = 0; index < registrations.length; index += 1) {
            if (registrations[index].root.contains(element)) return registrations[index];
        }
        return null;
    }

    function rowContext(target) {
        var reactRow = target.closest && target.closest(REACT_ROW);
        var registration = reactRow && registrationFor(reactRow);
        if (registration) {
            return {
                row: reactRow,
                panel: reactRow.querySelector(REACT_PANEL),
                id: reactRow.getAttribute('data-react-swipe-id'),
                registration: registration,
                react: true
            };
        }
        var legacyRow = target.closest && target.closest(ROW);
        if (!legacyRow) return null;
        return {
            row: legacyRow,
            panel: legacyRow.querySelector(PANEL),
            id: legacyRow.getAttribute('data-swipe-id'),
            registration: null,
            react: false
        };
    }

    function notifyOpen(registration, id) {
        if (registration && registration.callbacks.onOpenChange) {
            registration.callbacks.onOpenChange(id);
        }
    }

    function closeAll() {
        $(PANEL).removeClass('translate-x-0').addClass('translate-x-full');
        registrations.slice().forEach(function(registration) {
            notifyOpen(registration, null);
        });
    }

    function refresh() {
        var useSwipe = shouldUseSwipeInterface();
        if (useSwipe) {
            $(DESKTOP).addClass('hidden');
            $(PANEL).removeClass('hidden').each(function() {
                window.LucideIcons && window.LucideIcons.initialize(this);
            });
        } else {
            $(DESKTOP).removeClass('hidden');
            $(PANEL).addClass('hidden');
        }
        registrations.slice().forEach(function(registration) {
            if (registration.callbacks.onDeviceChange) {
                registration.callbacks.onDeviceChange(useSwipe);
            }
            if (!useSwipe) notifyOpen(registration, null);
        });
    }

    function actionContext(target) {
        var reactButton = target.closest && target.closest(REACT_ACTION);
        var registration = reactButton && registrationFor(reactButton);
        if (registration) {
            var reactRow = reactButton.closest(REACT_ROW);
            return reactRow ? {
                action: reactButton.getAttribute('data-react-swipe-action'),
                id: reactRow.getAttribute('data-react-swipe-id'),
                row: reactRow,
                button: reactButton,
                registration: registration
            } : null;
        }
        var legacyButton = target.closest && target.closest(ACTION);
        var legacyRow = legacyButton && legacyButton.closest(ROW);
        return legacyRow ? {
            action: legacyButton.getAttribute('data-swipe-action'),
            id: legacyRow.getAttribute('data-swipe-id'),
            row: legacyRow,
            button: legacyButton,
            registration: null
        } : null;
    }

    function dispatchAction(context) {
        var detail = { action: context.action, id: context.id, row: context.row, button: context.button };
        if (context.registration) {
            if (context.registration.callbacks.onAction) context.registration.callbacks.onAction(detail);
            return;
        }
        context.row.dispatchEvent(new CustomEvent('swipe-action', { bubbles: true, detail: detail }));
    }

    function clearGesture(registration) {
        if (registration && (!currentGesture || currentGesture.registration !== registration)) return;
        clearTimeout(dragReleaseTimer);
        dragReleaseTimer = null;
        currentGesture = null;
        window.isDragging = false;
    }

    function onTouchStart(event) {
        if (actionContext(event.target)) actionHandledButton = null;
        if (!shouldUseSwipeInterface()) return;
        var context = rowContext(event.target);
        if (!context) {
            closeAll();
            return;
        }
        var touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        window.isDragging = false;
        currentGesture = context;
        closeAll();
    }

    function onTouchMove(event) {
        if (!shouldUseSwipeInterface() || !currentGesture) return;
        var context = rowContext(event.target);
        if (!context || context.row !== currentGesture.row) return;
        var touch = event.touches[0];
        var deltaX = touchStartX - touch.clientX;
        var deltaY = Math.abs(touchStartY - touch.clientY);
        if (deltaY > VERTICAL_ABORT_PX || Math.abs(deltaX) <= DIRECTION_LOCK_PX) return;
        window.isDragging = true;
        event.preventDefault();
        if (deltaX > REVEAL_THRESHOLD_PX) {
            if (context.react) notifyOpen(context.registration, context.id);
            else $(context.panel).removeClass('translate-x-full').addClass('translate-x-0');
        } else if (deltaX < -HIDE_THRESHOLD_PX) {
            if (context.react) notifyOpen(context.registration, null);
            else $(context.panel).removeClass('translate-x-0').addClass('translate-x-full');
        }
    }

    function onTouchEnd(event) {
        var action = actionContext(event.target);
        if (action && actionHandledButton !== action.button) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            actionHandledButton = action.button;
            dispatchAction(action);
        }
        if (!shouldUseSwipeInterface() || !currentGesture) return;
        clearTimeout(dragReleaseTimer);
        dragReleaseTimer = setTimeout(function() { clearGesture(); }, DRAG_RELEASE_MS);
    }

    function onTouchCancel() {
        if (shouldUseSwipeInterface()) clearGesture();
    }

    function onClick(event) {
        var action = actionContext(event.target);
        if (!action) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (actionHandledButton === action.button) {
            actionHandledButton = null;
            return;
        }
        dispatchAction(action);
    }

    function attachListeners() {
        if (listenersAttached) return;
        listenersAttached = true;
        document.addEventListener('touchstart', onTouchStart);
        document.addEventListener('touchmove', onTouchMove, { passive: false });
        document.addEventListener('touchend', onTouchEnd);
        document.addEventListener('touchcancel', onTouchCancel);
        document.addEventListener('click', onClick);
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(refresh, RESIZE_DEBOUNCE_MS);
        });
        refresh();
    }

    function register(root, callbacks) {
        var registration = { root: root, callbacks: callbacks || {}, disposed: false };
        registrations.push(registration);
        if (registration.callbacks.onDeviceChange) {
            registration.callbacks.onDeviceChange(shouldUseSwipeInterface());
        }
        return function() {
            if (registration.disposed) return;
            registration.disposed = true;
            registrations = registrations.filter(function(candidate) {
                return candidate !== registration;
            });
            if (currentGesture && currentGesture.registration === registration) clearGesture(registration);
            if (actionHandledButton && registration.root.contains(actionHandledButton)) {
                actionHandledButton = null;
            }
            notifyOpen(registration, null);
        };
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachListeners, { once: true });
    } else {
        attachListeners();
    }

    window.SwipeActions = {
        refresh: refresh,
        closeAll: closeAll,
        register: register,
        shouldUseSwipeInterface: shouldUseSwipeInterface
    };
})();
